import { render, staticRenderFns } from "./SalesOrderComponents.vue?vue&type=template&id=872d26ac&"
import script from "./SalesOrderComponents.vue?vue&type=script&lang=js&"
export * from "./SalesOrderComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports